if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
// CD CODE


if (!document.querySelector('.template_new-product')) return;

const thumbnails = document.querySelectorAll('.thumbnail-list__item');
const sizeEl = document.querySelector('.Size[data-index]');
const colorEl = document.querySelector('.Color[data-index]');
const fitEl = document.querySelector('.Pack[data-index]') || document.querySelector('.choose_your_fit input:checked');

function formatText(val){
  if(!val) return '';
  return val.replace('For ','_').replace(/\s+/g,'_').toLowerCase();
}

function getVariantKey(){
  let key = '';

  const color = colorEl ? formatText(variant.options[colorEl.dataset.index]) : '';
  const size = sizeEl ? formatText(variant.options[sizeEl.dataset.index]) : '';
  const fit  = fitEl ? formatText(variant.options[fitEl.dataset.index || fitEl.value]) : '';

  if(color) key += color;
  if(fit) key += (key ? '_' : '') + 'fit' + fit;
  if(size) key += (key ? '_' : '') + 'size_' + size;

  return key;
}

const key = getVariantKey();
const targetClass = 'color_' + key;

let found = false;

for (let i = 0; i < thumbnails.length; i++) {
  const el = thumbnails[i];

  if (el.className.includes(targetClass)) {
    el.style.display = '';
    if (!found) {
      const thumb = el.querySelector('.thumbnail');
      if (thumb) thumb.click();
      found = true;
    }
  } else {
    el.style.display = 'none';
  }
}

if (!found) {
  thumbnails.forEach(el => el.style.display = '');
}

          // if(document.querySelector('.template_new-product')){
          //   var current_var = '';
          //   var current_index_fit = document.querySelector('.choose_your_fit input:checked').value;
          //   var current_index_size = document.querySelector('.Size[data-index]').getAttribute('data-index');
          //   var current_index_color = document.querySelector('.Color[data-index]').getAttribute('data-index');
          //   if(variant.options[current_index_fit] != undefined){
          //     var text_dawncase_fit = variant.options[current_index_fit].replace('For ', '_').replace(' ', '_').toLowerCase();
          //   }
          //   var text_dawncase_size = variant.options[current_index_size].replace(' ', '_').toLowerCase();
          //   var text_dawncase_color = variant.options[current_index_color].replace(' ', '_').toLowerCase();
          //   if(text_dawncase_color != ''){
          //     current_var += text_dawncase_color;
          //   }
          //   if(variant.options[current_index_fit] != undefined){
          //     if(current_var == ''){
          //       current_var = 'fit'+text_dawncase_fit;
          //     }else{
          //       current_var += '_';
          //       current_var += 'fit'+text_dawncase_fit;
          //     }
          //   }
          //   if(text_dawncase_size != ''){
          //     if(current_var == ''){
          //       current_var = 'size_'+text_dawncase_size;
          //     }else{
          //       current_var += '_';
          //       current_var += 'size_'+text_dawncase_size;
          //     }
          //   }
          //   console.log('color_'+current_var)
          //   // var current_class = 'color_' + text_dawncase;
          //   if(document.querySelectorAll('.thumbnail-list__item:not([class*="color_'+current_var+'"])').length){
          //     document.querySelectorAll('.thumbnail-list__item:not([class*="color_'+current_var+'"])').forEach(function(e){
          //       e.style.display = 'none';
          //     })
          //   }
          //   if(document.querySelectorAll('.thumbnail-list__item[class*="color_'+current_var+'"]').length){
          //     document.querySelectorAll('.thumbnail-list__item[class*="color_'+current_var+'"]').forEach(function(e){
          //       e.style.display = 'block';
          //     })
              
          //     setTimeout(function(){
          //       document.querySelector('.thumbnail-list__item[class*="color_'+current_var+'"] .thumbnail').click();
          //     }, 600);
          //   }else{
          //     document.querySelectorAll('.thumbnail-list__item').forEach(function(e){
          //       e.style.display = 'block';
          //     })
          //     setTimeout(function(){
          //       document.querySelector('.thumbnail-list__item .thumbnail').click();
          //     }, 600);
          //   }
          // }

          // if(document.querySelector('.template_new-product')){
          //   var single_current_var = '';
          //   var double_current_var = '';
          //   var triple_current_var = '';
          //   if(document.querySelector('.Pack[data-index]') != null){
          //     var current_index_fit = document.querySelector('.Pack[data-index]').getAttribute('data-index');
          //   }
          //   var current_index_size = document.querySelector('.Size[data-index]').getAttribute('data-index');
          //   var current_index_color = document.querySelector('.Color[data-index]').getAttribute('data-index');
          //   // if(document.querySelector('.Pack[data-index]') != null){
          //   //   if(variant.options[current_index_fit] != undefined){
          //   //     var text_dawncase_fit = variant.options[current_index_fit].replace('For ', '_').replace(' ', '_').toLowerCase();
          //   //   }
          //   // }
          //   if(document.querySelector('.choose_your_fit input:checked') != null){
          //     var text_dawncase_fit = document.querySelector('.choose_your_fit input:checked').value.replace('For ', '_').replace(' ', '_').toLowerCase();
          //   }
          //   var text_dawncase_size = variant.options[current_index_size].replace(' ', '_').toLowerCase();
          //   var text_dawncase_color = variant.options[current_index_color].replace(' ', '_').toLowerCase();
          //   if(text_dawncase_color != ''){
          //     triple_current_var += text_dawncase_color;
          //     single_current_var += text_dawncase_color;
          //     double_current_var += text_dawncase_color;
          //   }
          //   if(variant.options[current_index_fit] != undefined || text_dawncase_fit != null){
          //     if(triple_current_var == ''){
          //       triple_current_var = 'fit'+text_dawncase_fit;
          //       double_current_var = 'fit'+text_dawncase_fit;
          //     }else{
          //       triple_current_var += '_';
          //       triple_current_var += 'fit'+text_dawncase_fit;
          //       double_current_var += '_';
          //       double_current_var += 'fit'+text_dawncase_fit;
          //     }
          //   }
          //   if(text_dawncase_size != ''){
          //     if(triple_current_var == ''){
          //       triple_current_var = 'size_'+text_dawncase_size;
          //     }else{
          //       triple_current_var += '_';
          //       triple_current_var += 'size_'+text_dawncase_size;
          //     }
          //   }

          //   var current_value = "";
          //   if(document.querySelectorAll('.thumbnail-list__item.color_'+triple_current_var).length){
          //     current_value = triple_current_var;
          //   }else if(document.querySelectorAll('.thumbnail-list__item.color_'+double_current_var).length){
          //     current_value = double_current_var;
          //   }else if(document.querySelectorAll('.thumbnail-list__item.color_'+single_current_var).length){
          //     current_value = single_current_var;
          //   }
            
          //   // var current_class = 'color_' + text_dawncase;
          //   if(document.querySelectorAll('.thumbnail-list__item.color_'+current_value).length){
          //     document.querySelectorAll('.thumbnail-list__item:not(.color_'+current_value+')').forEach(function(e){
          //       e.style.display = 'none';
          //     })
          //   }
            
          //   if(current_value != ''){
          //     document.querySelectorAll('.thumbnail-list__item.color_'+current_value).forEach(function(e){
          //       e.style.display = 'block';
          //     })
              
          //     setTimeout(function(){
          //       document.querySelector('.thumbnail-list__item.color_'+current_value+' .thumbnail').click();
          //     }, 600);
          //   }else{
          //     document.querySelectorAll('.thumbnail-list__item').forEach(function(e){
          //       e.style.display = 'block';
          //     })
          //     setTimeout(function(){
          //       document.querySelector('.thumbnail-list__item .thumbnail').click();
          //     }, 600);
          //   }
          // }

          if (!variant) {
            this.setUnavailable();
            return;
          }

          if(!document.querySelector('.thumbnail-list .thumbnail-list__item[class*="color_"]') && !document.querySelector('.template_new-product')){
          this.updateMedia(html, variant?.featured_media?.id);
          }

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          if (document.querySelector('.template_new-product')) {

            const packEls = document.querySelector('.Pack[data-index]');
            const sizeEls = document.querySelector('.Size[data-index]');
            const colorEls = document.querySelector('.Color[data-index]');
            const fitEls = document.querySelector('.choose_your_fit input:checked');

            let singleVar = '';
            let doubleVar = '';
            let tripleVar = '';

            const fitIndex = packEls?.getAttribute('data-index');
            const sizeIndex = sizeEls?.getAttribute('data-index');
            const colorIndex = colorEls?.getAttribute('data-index');

            const formatText = (text) => text?.replace('For ', '_').replace(/\s+/g, '_').toLowerCase() || '';

            const fitText = formatText(fitEls?.value);
            const sizeText = formatText(variant.options[sizeIndex]);
            const colorText = formatText(variant.options[colorIndex]);

            if (colorText) {
              singleVar = colorText;
              doubleVar = colorText;
              tripleVar = colorText;
            }

            if (fitText) {
              const fitVal = 'fit' + fitText;

              if (!tripleVar) {
                tripleVar = fitVal;
                doubleVar = fitVal;
              } else {
                tripleVar += '_' + fitVal;
                doubleVar += '_' + fitVal;
              }
            }
            console.log('calllll', singleVar, doubleVar, tripleVar)
            if (sizeText) {
              const sizeVal = 'size_' + sizeText;
              tripleVar = tripleVar ? tripleVar + '_' + sizeVal : sizeVal;
            }

            const thumbList = document.querySelectorAll('.thumbnail-list__item');

            const selectors = [
              '.thumbnail-list__item.color_' + tripleVar,
              '.thumbnail-list__item.color_' + doubleVar,
              '.thumbnail-list__item.color_' + singleVar
            ];

            let currentValue = '';

            for (let sel of selectors) {
              if (document.querySelector(sel)) {
                currentValue = sel.split('color_')[1];
                break;
              }
            }

            thumbList.forEach(el => {
              el.style.display = currentValue && !el.classList.contains('color_' + currentValue)
                ? 'none'
                : 'block';
            });

            let thumbClick = document.querySelector('.thumbnail-list__item.color_' + currentValue + ' .thumbnail')
                          || document.querySelector('.thumbnail-list__item .thumbnail');

            thumbClick?.click();
          }

          if(document.querySelector('.template_new-product') && document.querySelector('.hide_variant_price')){
            if(document.querySelector('.choose_your_fit input:checked')){
              var current_index_fit = document.querySelector('.choose_your_fit input:checked').value;
            }
            var current_pack = document.querySelector('.meta-pack:not(.choose_your_fit) input:checked').value;
            if(document.querySelector('.choose_your_fit input:checked')){
              var current_text_value = current_pack + '/' + current_index_fit;
            }else{
              var current_text_value = current_pack;
            }
            var current_rag_price = document.querySelector('.hide_variant_price option[value="'+ current_text_value +'"]').getAttribute('data-price');
            var current_rag_com_price = document.querySelector('.hide_variant_price option[value="'+ current_text_value +'"]').getAttribute('data-compare');
            // var current_percentage = document.querySelector('.hide_variant_price option[value="'+ current_text_value +'"]').getAttribute('data-percent');
            document.querySelector('.pdp_price .price__sale .price-item--sale').innerHTML = current_rag_price;
            document.querySelector('.pdp_price .price__sale .price-item--regular').innerHTML = current_rag_com_price;
            // document.querySelector('.pdp_price .price__sale .custom_discount').innerHTML = 'Save '+ +current_percentage +' TODAY';
          }else{
            updateSourceFromDestination('price');
          }
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

// CD CODE

document.addEventListener("DOMContentLoaded", function(event) {
  if(document.querySelector('.template_new-product .choose_your_fit input:checked')){
    var rd_current_index = document.querySelector('.choose_your_fit input:checked').value;
    var rd_text_dawncase = rd_current_index.replace(' ', '-').toLowerCase();
    var rd_current_class = 'color_' + rd_text_dawncase;
    if(document.querySelectorAll('.thumbnail-list__item:not(.'+ rd_current_class +')').length){
      document.querySelectorAll('.thumbnail-list__item:not(.'+ rd_current_class +')').forEach(function(e){
        e.style.display = 'none';
      })
    }
    if(document.querySelectorAll('.thumbnail-list__item.'+ rd_current_class).length){
      document.querySelectorAll('.thumbnail-list__item.'+ rd_current_class).forEach(function(e){
        e.style.display = 'block';
      })
      
      setTimeout(function(){
        document.querySelector('.thumbnail-list__item.'+ rd_current_class + ' .thumbnail').click();
      }, 600);
    }
  }
  // if(document.querySelector('.template_new-product')){
  //   var rd_current_var = '';
  //   var rd_current_index_fit = document.querySelector('.choose_your_fit input:checked').value;
  //   var rd_current_index_size = document.querySelector('.Size input:checked').value;
  //   var rd_current_index_color = document.querySelector('.Color input:checked').value;
  //   var rd_text_dawncase_fit = rd_current_index_fit.replace('For ', '_').replace(' ', '_').toLowerCase();
  //   var rd_text_dawncase_size = rd_current_index_size.replace(' ', '_').toLowerCase();
  //   var rd_text_dawncase_color = rd_current_index_color.replace(' ', '_').toLowerCase();
  //   if(rd_text_dawncase_color != ''){
  //     rd_current_var += rd_text_dawncase_color;
  //   }
  //   if(rd_text_dawncase_fit != ''){
  //     if(rd_current_var == ''){
  //       rd_current_var = 'fit'+rd_text_dawncase_fit;
  //     }else{
  //       rd_current_var += '&';
  //       rd_current_var += 'fit'+rd_text_dawncase_fit;
  //     }
  //   }
  //   if(rd_text_dawncase_size != ''){
  //     if(rd_current_var == ''){
  //       rd_current_var = 'size_'+rd_text_dawncase_size;
  //     }else{
  //       rd_current_var += '&';
  //       rd_current_var += 'size_'+rd_text_dawncase_size;
  //     }
  //   }
  //   // var current_class = 'color_' + text_dawncase;
  //   if(document.querySelectorAll('.thumbnail-list__item:not([class*="color_'+rd_current_var+'"])').length){
  //     document.querySelectorAll('.thumbnail-list__item:not([class*="color_'+rd_current_var+'"])').forEach(function(e){
  //       e.style.display = 'none';
  //     })
  //   }
  //   if(document.querySelectorAll('.thumbnail-list__item[class*="color_'+rd_current_var+'"]').length){
  //     document.querySelectorAll('.thumbnail-list__item[class*="color_'+rd_current_var+'"]').forEach(function(e){
  //       e.style.display = 'block';
  //     })
      
  //     setTimeout(function(){
  //       document.querySelector('.thumbnail-list__item[class*="color_'+rd_current_var+'"] .thumbnail').click();
  //     }, 600);
  //   }else{
  //     document.querySelectorAll('.thumbnail-list__item').forEach(function(e){
  //       e.style.display = 'block';
  //     })
  //     setTimeout(function(){
  //       document.querySelector('.thumbnail-list__item .thumbnail').click();
  //     }, 600);
  //   }
  // }


  if(document.querySelector('.template_new-product')){

  var single_current_var = '';
  var double_current_var = '';
  var triple_current_var = '';

  if(document.querySelector('.choose_your_fit input:checked')){
    var rd_current_fit = document.querySelector('.choose_your_fit input:checked').value;
  }else{
    var rd_current_fit = document.querySelector('.Pack input:checked')?.value || '';
  }
  var rd_current_size = document.querySelector('.Size input:checked')?.value || '';
  var rd_current_color = document.querySelector('.Color input:checked')?.value || '';;

  var text_dawncase_fit = rd_current_fit.replace('For ', '_').replace(' ', '_').toLowerCase();
  var text_dawncase_size = rd_current_size.replace(' ', '_').toLowerCase();
  var text_dawncase_color = rd_current_color.replace(' ', '_').toLowerCase();

  // COLOR
  if(text_dawncase_color != ''){
    triple_current_var += text_dawncase_color;
    single_current_var += text_dawncase_color;
    double_current_var += text_dawncase_color;
  }

  // FIT
  if(text_dawncase_fit != ''){
    if(triple_current_var == ''){
      triple_current_var = 'fit'+text_dawncase_fit;
      double_current_var = 'fit'+text_dawncase_fit;
    }else{
      triple_current_var += '_fit'+text_dawncase_fit;
      double_current_var += '_fit'+text_dawncase_fit;
    }
  }

  // SIZE
  if(text_dawncase_size != ''){
    if(triple_current_var == ''){
      triple_current_var = 'size_'+text_dawncase_size;
    }else{
      triple_current_var += '_size_'+text_dawncase_size;
    }
  }

  var current_value = "";

  if(document.querySelectorAll('.thumbnail-list__item.color_'+triple_current_var).length){
    current_value = triple_current_var;
  }else if(document.querySelectorAll('.thumbnail-list__item.color_'+double_current_var).length){
    current_value = double_current_var;
  }else if(document.querySelectorAll('.thumbnail-list__item.color_'+single_current_var).length){
    current_value = single_current_var;
  }

  if(current_value != ''){
    document.querySelectorAll('.thumbnail-list__item').forEach(function(e){
      e.style.display = 'none';
    });

    document.querySelectorAll('.thumbnail-list__item.color_'+current_value).forEach(function(e){
      e.style.display = 'block';
    });

    setTimeout(function(){
      document.querySelector('.thumbnail-list__item.color_'+current_value+' .thumbnail')?.click();
    }, 600);

  }else{
    document.querySelectorAll('.thumbnail-list__item').forEach(function(e){
      e.style.display = 'block';
    });

    setTimeout(function(){
      document.querySelector('.thumbnail-list__item .thumbnail')?.click();
    }, 600);
  }
}
});